import { registerPlugin } from '@capacitor/core';

/** Das native Gegenstück `ios/App/App/GeraetelogPlugin.swift` — nur am iPad da. */
export interface GeraetelogPlugin {
  /** Schreibende Anweisungen nach `Documents/log-sql.txt` (`persistence/sqlLog.ts`). */
  sql(optionen: { zeilen: string[] }): Promise<void>;
  /** Eine Datei unter `Documents` als rohes Deflate; `crc`/`groesse` des ungepackten Inhalts. */
  packe(optionen: { pfad: string }): Promise<{ base64: string; crc: number; groesse: number }>;
}

export const Geraetelog = registerPlugin<GeraetelogPlugin>('Geraetelog');
